<template>
  <div class="special-function-query" style="height: calc(100% - 175px)">
    <special-function-base-query
      @change="baseQueryChange"
    ></special-function-base-query>
    <dynamic-query
      :bid="queryFormObj.bid"
      :product="queryFormObj.product"
      @change="dynamicQueryChange"
      @columns-change="columnsChange"
    ></dynamic-query>
    <base-table-new
      sendJson
      :isSendToken="false"
      ref="table"
      :query="queryFormObj"
      :initSearch="false"
      :actionReload="true"
      url="special/get"
      :columns="columns"
    >
    </base-table-new>
  </div>
</template>
<script>
export default {
  name: 'special-function-query',
  data() {
    return {
      userArr: [],
      currSelectIdx: -1,
      queryFormObj: {
        bid: '',
        product: '',
      },
      formItems: [],
      columns: [],
    }
  },
  created() {
    this.$setLang('en')
  },
  methods: {
    baseQueryChange(val) {
      this.queryFormObj.bid = val.bid
      this.queryFormObj.product = val.product
      this.refreshTable()
    },
    dynamicQueryChange(val) {
      for (var key in val) {
        this.$set(this.queryFormObj, key, val[key])
      }
      this.refreshTable()
    },
    columnsChange(columns) {
      this.columns = columns
    },
    refreshTable() {
      if (this.queryFormObj.bid) {
        this.$refs.table.query.PageIndex = 1
        this.$refs.table.refreshData()
      } else {
        this.$refs.table.setTableData({})
      }
    },
  },
}
</script>
<style lang="less">
.special-function-query {
  .el-table .cell {
    word-break: normal;
  }

  .el-form--inline .el-form-item {
    margin-right: 0;
  }
}
</style>